import React from "react";
import { Button } from "antd";
import { history } from "router";
import QueryString from "query-string";

const StageBucketAction = (
    actionPermissionMap,
    stageId,
    stageName,
    isStageAdmin,
    selectedViewType
) => {
    const ActionLink = (_, record) => {
        const searchParams = QueryString.parse(window.location.search);
        const assigned_user = record.current_case_task && 
        record.current_case_task && 
        record.current_case_task.this_user &&
        record.current_case_task.this_user.id;
        if (!assigned_user && !searchParams.stage == "7") {
            return (
                <Button
                    type={"link"}
                    size={"small"}
                    onClick={() =>
                        history.replace("/app/inbox", {
                            case_actions: {
                                action: "ASSIGN",
                                case_id: record.id,
                                stage_id: stageId,
                                stage_name: stageName,
                                case_task_id: record.case_task_id,
                                selectedCasesType: selectedViewType
                            }
                        })
                    }
                >
                    Assign
                </Button>
            );
        }else if(isStageAdmin && searchParams.stage == "7"){
            return (
                <Button
                    type={"link"}
                    size={"small"}
                    onClick={() =>
                        history.replace("/app/inbox", {
                            case_actions: {
                                action: "ASSIGN",
                                case_id: record.id,
                                stage_id: stageId,
                                stage_name: stageName,
                                case_task_id: record.case_task_id,
                                selectedCasesType: selectedViewType
                            }
                        })
                    }
                >
                    Assign
                </Button>
            );
        }
        if (assigned_user && isStageAdmin && selectedViewType !== "hold" && selectedViewType !== "rejected") {
            return (
                <Button
                    type={"link"}
                    size={"small"}
                    onClick={() =>
                        history.replace("/app/inbox", {
                            case_actions: {
                                action: "REASSIGN",
                                case_id: record.id,
                                stage_id: stageId,
                                stage_name: stageName,
                                case_task_id: record.case_task_id,
                                selectedCasesType: selectedViewType
                            }
                        })
                    }
                >
                    Reassign
                </Button>
            );
        }
        if (assigned_user && isStageAdmin && selectedViewType === "hold") {
            return (
                <Button
                    type={"link"}
                    size={"small"}
                    onClick={() =>
                        history.replace("/app/inbox", {
                            case_actions: {
                                action: "OPEN",
                                case_id: record.id,
                                stage_id: stageId,
                                stage_name: stageName,
                                case_task_id: record.case_task_id,
                                selectedCasesType: selectedViewType
                            }
                        })
                    }
                >
                    Open
                </Button>
            );
        }
        if (assigned_user && isStageAdmin && selectedViewType === "rejected") {
            return (
                <Button
                    type={"link"}
                    size={"small"}
                    onClick={() =>
                        history.replace("/app/inbox", {
                            case_actions: {
                                action: "OPEN",
                                case_id: record.id,
                                stage_id: stageId,
                                stage_name: stageName,
                                case_task_id: record.case_task_id,
                                selectedCasesType: selectedViewType
                            }
                        })
                    }
                >
                    Open
                </Button>
            );
        }
        return null;
    };
    return ActionLink;
};

export default StageBucketAction;
